import { Component, EventEmitter, Input, OnInit, Output, ViewChildren } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-sign-document-otp',
  templateUrl: './sign-document-otp.component.html',
  styleUrls: ['./sign-document-otp.component.css']
})
export class SignDocumentOtpComponent implements OnInit{

  @Input() label:string;
  @Input() subLabel:string;
  @Input() isPin: boolean;

  formInput = ['input1', 'input2', 'input3', 'input4', 'input5', 'input6', 'input7', 'input8'];
  @ViewChildren('formRow') rows: any;

  @Output() otpChange: EventEmitter<string> = new EventEmitter();

  formOtpPin : FormGroup;
  showPin: boolean;

  constructor(private formBuilder : FormBuilder) {
    this.formOtpPin = this.toFormGroup(this.formInput);
  }

  toFormGroup(elements) {
    const group: any = {};

    elements.forEach(key => {
      group[key] = new FormControl('', Validators.required);
    });
    return new FormGroup(group);
  }

  ngOnInit() {
    this.showPin = true;
    if (this.isPin) {
      this.showPin = false;
    }
  }

  check(){
    if(this.formOtpPin.valid){
      this.otpChange.emit('');
    } else {
      this.otpChange.emit(undefined);
    }
  }

  keyUpEvent(event, index) {
    let pos = index;
    if (event.keyCode === 8 && event.which === 8) {
     pos = index - 1 ;
    } else {
     pos = index + 1 ;
    }
    if (pos > -1 && pos < this.formInput.length ) {
     this.rows._results[pos].nativeElement.focus();
    }
    if(this.formOtpPin.valid){
      let out = ''
      this.formInput.forEach(element => {
        const value = this.formOtpPin.value[element];
        out = out + value;
      });

      this.otpChange.emit(out)
    } else {
      this.otpChange.emit(undefined)
    }
   }
}
